import React from "react";
import { Input } from "../../ui/input";
import { Button } from "../../ui/button";
import { Search, Loader2, Check } from "lucide-react";

export function CedenteSearch({ 
  query, 
  setQuery, 
  cedentes, 
  loading, 
  onSelect, 
  selectedId,
  currentPage,
  totalPages,
  onPageChange,
  isDebouncing
}) {
  return (
    <>
      <div className="relative">
          <Search className="absolute left-2 top-2.5 h-4 w-4 text-muted-foreground" />
          <Input 
              placeholder="Buscar por nome ou CPF..." 
              className="pl-8"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
          />
          {isDebouncing && (
            <div className="absolute right-3 top-2.5 flex items-center text-xs text-muted-foreground gap-1 animate-pulse">
                <Loader2 className="w-3 h-3 animate-spin" />
                Buscando...
            </div>
          )}
      </div>

      <div className="flex-1 min-h-0 overflow-y-auto space-y-2 border rounded-md p-2">
          {loading ? (
              <div className="flex justify-center items-center h-48 text-muted-foreground">
                  <Loader2 className="h-6 w-6 animate-spin mr-2" /> Carregando...
              </div>
          ) : (
              <>
                {cedentes.map(cedente => (
                    <div 
                        key={cedente.id} 
                        className={`flex items-center justify-between p-2 rounded cursor-pointer transition-colors ${selectedId === cedente.id ? 'bg-statusInfoBg border border-statusInfo/20' : 'hover:bg-muted border border-transparent'}`}
                        onClick={() => onSelect(cedente)}
                    >
                        <div className="text-sm">
                            <div className="font-medium">{cedente.nome}</div>
                            <div className="text-xs text-muted-foreground">{cedente.cpf}</div>
                        </div>
                        {selectedId === cedente.id && <Check className="h-4 w-4 text-blue-600" />}
                    </div>
                ))}
                {cedentes.length === 0 && (
                    <p className="text-sm text-muted-foreground text-center p-8">Nenhum substituído encontrado.</p>
                )}
              </>
          )}
      </div>

      {/* Pagination Controls */}
      {totalPages > 1 && (
        <div className="flex items-center justify-between pt-2 border-t mt-2">
            <Button 
                variant="outline" 
                size="xs" 
                disabled={currentPage === 1}
                onClick={() => onPageChange(currentPage - 1)}
                className="h-8 text-xs"
            >
                Anterior
            </Button>
            <span className="text-xs text-muted-foreground">
                Página {currentPage} de {totalPages}
            </span>
            <Button 
                variant="outline" 
                size="xs" 
                disabled={currentPage === totalPages}
                onClick={() => onPageChange(currentPage + 1)}
                className="h-8 text-xs"
            >
                Próxima
            </Button>
        </div>
      )}
    </>
  );
}
